import apiClient from '@u/apiClient'
import AddCommentToModelController from '@/wayfinder/actions/App/Http/Controllers/Comment/AddCommentToModelController'

// const base_errors = { deceased: {}, events: [] }
const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  addCommentToTaskDossier: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddCommentToModelController['/api/task-dossier/comment/{id}'].put({
            id: payload.task_dossier_id
          }),
          {
            text: payload.text
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  }
}
